import variables from './variables.module.scss';

const scssVariables = variables as {
  readonly breakpoint_599_px: string;
  readonly breakpoint_600_px: string;
  readonly breakpoint_899_px: string;
  readonly breakpoint_900_px: string;
  readonly breakpoint_1199_px: string;
  readonly breakpoint_1200_px: string;
  readonly breakpoint_1535_px: string;
  readonly breakpoint_1536_px: string;
  readonly breakpoint_2048_px: string;
  readonly breakpoint_2049_px: string;
};

const numericScssVariables = Object.fromEntries(
  Object.entries(scssVariables)
    .map<[string, number]>(([key, value]) => [key, parseInt(value)])
    .filter(([, numericValue]) => !isNaN(numericValue))
) as {
  readonly breakpoint_599_px: number;
  readonly breakpoint_600_px: number;
  readonly breakpoint_899_px: number;
  readonly breakpoint_900_px: number;
  readonly breakpoint_1199_px: number;
  readonly breakpoint_1200_px: number;
  readonly breakpoint_1535_px: number;
  readonly breakpoint_1536_px: number;
  readonly breakpoint_2048_px: number;
  readonly breakpoint_2049_px: number;
};

export { numericScssVariables };
